module.exports = __webpack_public_path__ + "static/media/emptyReceipts.1852e3c0.png";